import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "filter-toggle",
  class FilterToggle extends WYATTElement {
    constructor() {
      super({
        activeClass: "filters-collapse",
        toggleSelected: "button",
        elementSelector: "[data-filters-container]",
        storageKey: "hideFilters",
      });

      this.button = this.querySelector(this.config.toggleSelected);
      this.wrapper = document.querySelector(this.config.elementSelector);
      this.isHidden = localStorage.getItem(this.config.storageKey) === "true";

      if (this.wrapper) {
        if (this.isHidden) {
          this.hideFilters();
        }

        this.button.addEventListener("click", this.handleClick.bind(this));
      }
    }

    handleClick() {
      if (this.isHidden) {
        this.showFilters();
      } else {
        this.hideFilters();
      }
    }

    hideFilters() {
      try {
        this.isHidden = true;
        localStorage.setItem(this.config.storageKey, this.isHidden);
        this.wrapper.classList.add(this.config.activeClass);
        this.button.dataset.isHidden = this.isHidden;
      } catch (e) {
        this.handleError(e);
      }
    }

    showFilters() {
      try {
        this.isHidden = false;
        localStorage.setItem(this.config.storageKey, this.isHidden);
        this.wrapper.classList.remove(this.config.activeClass);
        this.button.dataset.isHidden = this.isHidden;
      } catch (e) {
        this.handleError(e);
      }
    }

    handleError(error) {
      if (error.name === "QuotaExceededError") {
        window.console.warn("Storage limit reached or exceeded");
      } else {
        window.console.error("Error toggling filter", error);
      }
    }
  },
);
